import { defineStore } from 'pinia'
import { ref , reactive} from 'vue'

export interface ArticleData {
  id: number,
  cid: number,
  cname: string,
  userId: number,
  username: string,
  avatar: string,
  title: string,
  content: string;
  firstImg: string;
  imgAddr: string;
  bt: string;
  btName: string;
  btAddr: string;
  imgNum: number;
  remarkNum: number;
  hot: number;
  top: number,
  look:number,
  reject: string;
  created: string,
  issDel: boolean,
  createdDate: Date,
  createdTime: number,
  imgList: Array<string>,
  comment: Array<any>,
}
export const useAppStore = defineStore('app', () => {
  // 状态
  const theme = ref<'light' | 'dark'>('light')
  const sidebarCollapsed = ref(false)
  const pageTitle = ref('View UI Plus Admin')
  const loading = ref(false)
  const linkStatus = ref('') // 客户端连接状态
  const homeIdx = ref(0) // 首页下标
  const windowMedia = reactive({
    innerHeight: '100%',
    innerWidth:'100%'
  })
  const article = ref<ArticleData | null>(null); // 详情
  const publish = ref(false); // 发布器，定时展示
  const showBar = ref(true); // 是否隐藏ActionBar，根据窗口高度

  const regex = /^[0-9零〇一二三四五六七八九壹贰叁肆伍陆柒捌玖幺两俩仨]+$/;
  // 动作
  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
    // 这里可以添加主题切换的逻辑
    document.documentElement.setAttribute('data-theme', theme.value)
  }

  const toggleSidebar = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  const setPageTitle = (title: string) => {
    pageTitle.value = title
    document.title = title
  }

  const setLoading = (status: boolean) => {
    loading.value = status
  }

  return {
    // 状态
    theme,
    sidebarCollapsed,
    pageTitle,
    loading,
    windowMedia,
    linkStatus,
    homeIdx,
    article,
    publish,
    showBar,
    // 动作
    toggleTheme,
    toggleSidebar,
    setPageTitle,
    setLoading
  }
})
